import axiosOG from 'axios';
import { setupAxios } from '@carvana/core-auth';
import Cookie from '../services/Cookie';

const axiosInstance = (config = { timeout: 0 }) => {
  const instance = axiosOG.create(config);
  const browserCookieId = Cookie.getCookie('BrowserCookieId');

  if (browserCookieId) {
    instance.defaults.headers.common.BrowserCookieId = browserCookieId;
  }
  instance.defaults.headers.common.IsHeaderRequest = true;

  return setupAxios(instance, { addBearerTokenToAllRequests: true });
};

export const axios = axiosInstance({ timeout: 3000 });
export const axiosWithConfig = (config = { timeout: 3000 }) => axiosInstance(config);
export const axiosWithTimeOut = timeout => axiosInstance({ timeout });
